<!-- Clean Layout with Fixed Topbar and Sidebar -->
<div class="app-layout">
  <!-- Top Bar Fixed -->
  <header class="app-topbar">
    <div class="topbar-left">
      <button type="button" class="menu-toggle" (click)="toggleSidebar()">
        <div class="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <div class="app-logo">
        <span class="logo-text">Zupit CodeQuality</span>
        <span class="logo-subtitle">Quality Metrics Platform</span>
      </div>
    </div>

    <div class="topbar-right">
      <app-theme-toggle></app-theme-toggle>
      <app-language-selector></app-language-selector>

      <!-- User Menu -->
      @if (currentUser(); as currentUser) {
        <div class="user-menu">
          <button type="button" class="user-button" (click)="userMenu.toggle($event)">
            <p-avatar [label]="getUserInitials()" shape="circle" class="user-avatar"> </p-avatar>
            <div class="user-info">
              <span class="user-name">{{ currentUser!.fullName }}</span>
              <span class="user-role">{{ getRoleLabel() }}</span>
            </div>
            <i class="pi pi-chevron-down user-chevron"></i>
          </button>

          <p-menu #userMenu [model]="userMenuItems()" [popup]="true" [appendTo]="'body'" class="user-dropdown-menu">
            <ng-template pTemplate="start">
              <div class="user-menu-header">
                <div class="user-info">
                  <span class="user-name">{{ currentUser!.fullName }}</span>
                  <span class="user-role">{{ getRoleLabel() }}</span>
                </div>
                <div class="user-email">{{ currentUser!.email }}</div>
                @if (currentUser!.teamName) {
                  <a [routerLink]="'/dashboard'" class="user-team user-team-link">
                    <i class="pi pi-sitemap"></i>
                    <span>{{ currentUser!.teamName }}</span>
                    <i class="pi pi-arrow-right team-arrow"></i>
                  </a>
                }
              </div>
            </ng-template>
          </p-menu>
        </div>
      }
    </div>
  </header>

  <!-- Sidebar -->
  <nav class="app-sidebar" [class.visible]="sidebarVisible()" [class.collapsed]="!sidebarVisible()">
    <div class="sidebar-nav">
      @for (item of menuItems(); track item.label) {
        <a [routerLink]="item.routerLink" class="nav-link" routerLinkActive="active" [title]="item.label">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      }
    </div>
  </nav>

  <!-- Main Content -->
  <main class="app-main" [class.sidebar-open]="sidebarVisible()">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Toast -->
  <p-toast></p-toast>
</div>
